var exports = {};
exports = {
  borderRadius: {
    badge: "var(--rounded-badge, 1.9rem)",
    btn: "var(--rounded-btn, 0.5rem)",
    box: "var(--rounded-box, 1rem)"
  }
};
export default exports;